import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeysShowSecret = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 1H20C21.6569 1 23 2.34315 23 4V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4C1 2.34315 2.34315 1 4 1ZM20 0C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4C0 1.79086 1.79086 0 4 0H20Z",
		fill: "#A3B8C2",
		fillOpacity: .3
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.7884 16.0461C9.61871 16.0461 7.38469 14.8319 5.6047 12.2728C7.38467 9.71409 9.61887 8.5 11.7887 8.5C13.9585 8.5 16.1927 9.71408 17.9726 12.2728C16.1923 14.8319 13.9581 16.0461 11.7884 16.0461ZM18.9939 11.9978C17.0511 9.04752 14.4544 7.5 11.7887 7.5C9.12297 7.5 6.52627 9.04752 4.58342 11.9978L4.40234 12.2727L4.58341 12.5477C6.52622 15.4983 9.12274 17.0461 11.7884 17.0461C14.454 17.0461 17.0507 15.4984 18.9939 12.5478L19.175 12.2728L18.9939 11.9978ZM11.0352 12.2721C11.0352 11.8565 11.3721 11.5195 11.7877 11.5195C12.2033 11.5195 12.5403 11.8565 12.5403 12.2721C12.5403 12.6877 12.2033 13.0247 11.7877 13.0247C11.3721 13.0247 11.0352 12.6877 11.0352 12.2721ZM11.7877 10.5195C10.8198 10.5195 10.0352 11.3042 10.0352 12.2721C10.0352 13.24 10.8198 14.0247 11.7877 14.0247C12.7556 14.0247 13.5403 13.24 13.5403 12.2721C13.5403 11.3042 12.7556 10.5195 11.7877 10.5195Z",
		fill: "#A3B8C2",
		fillOpacity: .7
	})]
});
export default SvgKeysShowSecret;
